import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// Present in every state: the retention promise and the fact that the page
// shows a stored copy rather than a recalculated one.
const VerifyFooter = ({ months }: { months: number }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={theme => ({
        mt: 4,
        pt: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Typography
        sx={theme => ({
          fontSize: "12.5px",
          color: theme.palette.text.secondary,
        })}
      >
        {t("verify.footer", { months })}
      </Typography>
    </Box>
  );
};

export default VerifyFooter;
